import {useContext} from 'react'
import {ReservationContext} from '../../context/ReservationContext'
import {OrderDataContext} from '../../context/OrderDataContext'
import config from '../../config'
import {Button} from "../Footer";
import {ErrorContext} from '../../context/ErrorContext'
import Api from "../../api/api";
import { TranslationContext } from '../../context/TranslationContext'

function TimeFooter({setPage}) {
    const {reservation} = useContext(ReservationContext)
    const {order} = useContext(OrderDataContext);
    const {setErrors} = useContext(ErrorContext);
    const {translations} = useContext(TranslationContext);

    let includedPrice = reservation.guests * config.price_per_guest;
    if (includedPrice < config.minimum_price) {
        includedPrice = config.minimum_price;
    }

    const changeToMenu = () => {
        if (!order.time) {
            setErrors((prev) => ({...prev, time: true}))
             Api.notify({
                text: 'Book breakfast click',
                data: {
                    reservationCode: reservation.code,
                    message: 'Time not selected. Marking time selector'
                }
            });
            return;
        }
        if (!order.location) {
            setErrors((prev) => ({...prev, location: true}))
             Api.notify({
                text: 'Book breakfast click',
                data: {
                    reservationCode: reservation.code,
                    message: 'Location not selected. Marking location selector'
                }
            });
            return;
        }
        setPage('menu');
        Api.notify({
            text: 'Book breakfast click',
            data: {
                reservationCode: reservation.code,
                time: order.time,
                message: 'Time selected. Allowing to continue'
            }
        });
    }

    return (
        <>
            <Button onClick={() => changeToMenu()}>{translations.next_step}</Button>
            <br/>
            <p>
                {translations.you_have} <strong>{includedPrice} €</strong> {translations.included_in_room}
            </p>
        </>
    );
}

export default TimeFooter;
